import Vue from 'vue'
import Router from 'vue-router'
import tokenStore from "./utils/tokenStore";

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/login',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: 'Login',
          path: '',
          component: () => import('@/views/pages/Login'),
        },
      ],
    },
    {
      path: '/',
      component: () => import('@/views/dashboard/Index'),
      children: [
        // Start page - for now - consignment stocks list
        {
          name: 'Consignment Stocks',
          path: '',
          component: () => import('@/views/dashboard/consignmentStocks/ConsignmentStocks'),
        },
        // Course
        {
          name: 'Course',
          path: 'course/course',
          component: () => import('@/views/dashboard/course/Training'),
        },
        {
          name: 'Course Edit',
          path: 'course/courseEdit/:id',
          component: () => import('@/views/dashboard/course/TrainingEdit'),
        },
        {
          name: 'Course Create',
          path: 'course/courseCreate',
          component: () => import('@/views/dashboard/course/TrainingCreate'),
        },
        // Course Template
        {
          name: 'Course Temlate',
          path: 'course/template',
          component: () => import('@/views/dashboard/course/TrainingTemplate'),
        },
        {
          name: 'Course Temlate edit',
          path: 'course/templateEdit/:id',
          component: () => import('@/views/dashboard/course/TrainingTemplateEdit'),
        },
        {
          name: 'Course Temlate create',
          path: 'course/templateCreate',
          component: () => import('@/views/dashboard/course/TrainingTemplateCreate'),
        },
        // Course Type
        {
          name: 'Course Type',
          path: 'course/type',
          component: () => import('@/views/dashboard/course/TrainingType'),
        },
        {
          name: 'Course Type Edit',
          path: 'course/typeEdit/:id',
          component: () => import('@/views/dashboard/course/TrainingTypeEdit'),
        },
        {
          name: 'Course Type Create',
          path: 'course/typeCreate',
          component: () => import('@/views/dashboard/course/TrainingTypeCreate'),
        },
        //Consignment Stocks 
        {
          name: 'Predefined Stocks',
          path: 'ConsignmentStocks/PredefinedStocks/List',
          component: () => import('@/views/dashboard/consignmentStocks/predefinedStocks/PredefinedStocks'),
        },
        {
          name: 'Create Predefined Stock',
          path: 'ConsignmentStocks/PredefinedStocks/Create',
          component: () => import('@/views/dashboard/consignmentStocks/predefinedStocks/PredefinedStocksCreate'),
        },
        {
          name: 'Edit Predefined Stock',
          path: 'ConsignmentStocks/PredefinedStocks/Edit/:id',
          component: () => import('@/views/dashboard/consignmentStocks/predefinedStocks/PredefinedStocksEdit'),
        },
        {
          name: 'Consignment Stocks',
          path: 'ConsignmentStocks/List',
          component: () => import('@/views/dashboard/consignmentStocks/ConsignmentStocks'),
        },
        {
          name: 'Create Consignment Stock',
          path: 'ConsignmentStocks/Create',
          component: () => import('@/views/dashboard/consignmentStocks/ConsignmentStocksCreate'),
        },
        {
          name: 'Edit Consignment Stock',
          path: 'ConsignmentStocks/Edit/:id',
          component: () => import('@/views/dashboard/consignmentStocks/ConsignmentStocksEdit'),
        },
        {
          name: 'Edit active Consignment Stock',
          path: 'ConsignmentStocks/ActiveEdit/:id',
          component: () => import('@/views/dashboard/consignmentStocks/ConsignmentStocksActiveEdit'),
        },
        {
          name: 'On error/closed Consignment Stock status',
          path: 'ConsignmentStocks/ErrorClosedStatus/:id',
          component: () => import('@/views/dashboard/consignmentStocks/ConsignmentStocksErrorClosedStatus'),
        },

      ],
    },
    {
      path: '*',
      component: () => import('@/views/pages/Index'),
      children: [
        {
          name: '404 Error',
          path: '',
          component: () => import('@/views/pages/Error'),
        },
      ],
    },
  ],
})

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const authRequired = !to.path.startsWith('/login')
  const loggedIn = !!tokenStore.getToken()

  if (authRequired && !loggedIn) {
    return next({
      path: '/login',
    })
  }

  next()
})
export default router
